import { createContext, useContext, useMemo } from "react";

const AnalysisRenderModeContext = createContext({ readOnly: false });

function AnalysisRenderModeProvider({ isReadOnlyMode, children }) {
    const value = useMemo(() => ({ isReadOnlyMode }), [isReadOnlyMode]);
    return (
        <AnalysisRenderModeContext.Provider value={value}>
            {children}
        </AnalysisRenderModeContext.Provider>
    );
}

function useIsReadOnlyMode() {
    const context = useContext(AnalysisRenderModeContext);
    return context?.isReadOnlyMode ?? false;
}

export { AnalysisRenderModeContext, AnalysisRenderModeProvider, useIsReadOnlyMode };
